import { Button, Col, Form, Modal, Row } from 'react-bootstrap';

const SuporteTiForm = props => {
  return (
    <Row>
      <Col sm={6}>
        <Form.Group controlId="telContatoTi" className="mt-4">
          <Form.Label>Telefone de Contato:</Form.Label>
          <Form.Control
            type="text"
            name="telContatoTi"
            onChange={e => props.handleTelContatoTi(e)}
            value={props.telContatoTi}
            placeholder="(21) 99999-9999"
          />
        </Form.Group>
      </Col>

      <Col sm={6}>
        <Form.Group controlId="patrimonioTi" className="mt-4">
          <Form.Label>
            {props.subcategoria.includes('Manutenção') &&
              props.subcategoria !== 'Manutenção de rede/internet' &&
              props.subcategoria !== 'Manutenção VOIP (Telefone Fixo)'
              ? '*Patrimônio'
              : 'Patrimônio'}
          </Form.Label>
          <Form.Control
            type="text"
            required={props.subcategoria.includes('Manutenção') ? true : false}
            name="patrimonioTi"
            onChange={e => props.handlePatrimonioTi(e)}
            value={props.patrimonioTi}
          />
        </Form.Group>
      </Col>
      
      <Modal show={props.showTiModal} onHide={props.handleTiModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Erro</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.tiError}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleTiModalClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </Row>
  );
};

export default SuporteTiForm;
